import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const faqs = [
  {
    q: "Do I need a deposit to rent a car in Bucharest?",
    a: "No. carentals.ro takes zero security deposit — no money is frozen or pre-authorised on your card, and there is no hold released weeks after the rental ends.",
  },
  {
    q: "Do I need a credit card to book?",
    a: "No credit card is required. You can pay with a debit card, in cash (EUR or RON) at pickup, or by bank transfer for company and long-term rentals.",
  },
  {
    q: "What documents do I need to rent a car?",
    a: "A driving licence held for at least 12 months and a passport or national ID card. No credit card and no proof of funds are needed.",
  },
  {
    q: "How old do I need to be to rent a car?",
    a: "The minimum age is 21, or 23 for the top of the luxury fleet. There is no young-driver surcharge added at handover.",
  },
  {
    q: "What is included in the price?",
    a: "Full insurance (CASCO and RCA), the rovinieta road vignette, free delivery in Bucharest and free delivery at Otopeni Airport are all included in the daily rate.",
  },
  {
    q: "What types of vehicles are available for rent?",
    a: "28 cars covering economy, compact, SUV and luxury models — all bookable with no deposit and no credit card.",
  },
  {
    q: "What is your fuel policy?",
    a: "Full-to-full: the car is delivered with a full tank and should be returned full, otherwise a refuelling charge applies.",
  },
  {
    q: "What happens if I return the car late?",
    a: "Additional charges apply based on the delay. Tell us in advance if you will be late and we will do our best to accommodate it.",
  },
];

export function FaqAccordion() {
  return (
    <Accordion type="single" collapsible className="w-full">
      {faqs.map((faq, i) => (
        <AccordionItem key={faq.q} value={`item-${i}`}>
          <AccordionTrigger className="text-left font-display text-base font-semibold">
            {faq.q}
          </AccordionTrigger>
          <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
            {faq.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
